import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, memo } from 'react';
import { Image, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import dayjs from 'dayjs';
import Auburn from '../../../../../../images/AuburnLogo.png';
;
export const PageThree = memo(({ pharmacy, traderInfo, user, }) => {
    const styles = StyleSheet.create({
        container: {
            padding: '20px 30px',
        },
        headerContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
            alignItems: 'center',
            marginBottom: 25,
        },
        image: {
            width: 75,
            height: 75,
        },
        title: {
            fontFamily: 'Roboto',
            fontWeight: 700,
            fontSize: 20,
            textAlign: 'center',
        },
        titleContainer: {
            flexDirection: 'column',
            padding: '5px 0px 5px 15px',
            justifyContent: 'center',
            textAlign: 'center',
            alignContent: 'center',
        },
        p: {
            fontSize: 12,
            fontFamily: 'Roboto',
        },
        pBlock: {
            fontSize: 11,
            fontFamily: 'Roboto',
            marginTop: 10,
        },
        section: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'nowrap',
            marginBottom: 10,
        },
        entry: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
        },
        sigsContainer: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            margin: '40px auto 20px',
        },
        col: {
            display: 'flex',
            justifyContent: 'flex-end',
            flexDirection: 'column',
        },
        footer: {
            textAlign: 'center',
        },
        footerText: {
            fontSize: 11,
            fontFamily: 'Roboto',
            fontWeight: 700,
        },
    });
    const { dateBusinessBegan, } = pharmacy;
    const businessBeganDayjs = dayjs(dateBusinessBegan);
    const formattedDateBusinessBegan = businessBeganDayjs.isValid()
        ? businessBeganDayjs.format('MM/DD/YYYY')
        : dateBusinessBegan;
    const ownerName = `${traderInfo.owner.firstName} ${traderInfo.owner.lastName}`;
    const sections = useMemo(() => [
        [
            { label: 'Company Name:', value: pharmacy.name, },
            {
                label: 'Multiple Locations or Pharmacies:',
                value: traderInfo.relatedToOtherFacilities ? 'Yes' : 'No',
            },
        ],
        [
            { label: 'DBA:', value: pharmacy.legalName, },
            {
                label: 'Date of Current Ownership:',
                value: formattedDateBusinessBegan,
            },
            { label: 'Phone:', value: pharmacy.phone, },
        ],
        [
            { label: 'Company Address:', value: pharmacy.address, },
            { label: 'City:', value: pharmacy.city, },
            { label: 'State:', value: pharmacy.state, },
            { label: 'Zip:', value: pharmacy.zipCode, },
        ],
        [
            { label: 'Federal ID #:', value: pharmacy.federalTaxNumber, },
            { label: 'Ownership Type', value: traderInfo.owner.ownershipType, }
        ],
        [
            { label: 'Owner/Officer Name:', value: ownerName, },
            { label: 'Accounts Payable Contact:', value: `${traderInfo.ap.firstName} ${traderInfo.ap.lastName}`, }
        ],
        [
            { label: 'Accounts Payable Email:', value: traderInfo.ap.email, },
            { label: 'Accounts Payable Phone #:', value: traderInfo.ap.phone, }
        ],
    ], []);
    const signatures = useMemo(() => {
        const date = dayjs().format('MM/DD/YYYY');
        return {
            left: [
                { label: 'Signature Company Grantor/Owner Grantor', value: null, },
                { label: 'Print Name', value: `${user.firstName} ${user.lastName}`, },
            ],
            right: [
                { label: 'Title', value: user.title, },
                { label: 'Date', value: date, }
            ],
        };
    }, []);
    return (_jsxs(Page, { size: 'A4', wrap: false, children: [_jsxs(View, { style: styles.container, children: [_jsxs(View, { style: styles.headerContainer, children: [_jsx(Image, { style: styles.image, src: Auburn }), _jsx(View, { style: styles.titleContainer, children: _jsx(Text, { style: styles.title, children: "Confidential Credit Agreement" }) })] }), sections.map((section, i) => (_jsx(View, { style: styles.section, children: section.map((entry, j) => (_jsxs(View, { style: styles.entry, children: [_jsx(Text, { style: { ...styles.p, marginRight: 5, fontSize: 10, }, children: entry.label }), _jsx(Text, { style: styles.p, children: entry.value })] }, j))) }, i))), _jsx(Text, { style: styles.pBlock, children: "All invoices are due by the 10th of each month and will be for purchases from the previous month. No alterations of payment conditions will be acknowledged unless approved by Auburn Pharmaceutical. All past due accounts over 30 days will be assessed 1.5% finance charge each month. In case of default, all reasonable collection and/or attorney fees will be assessed. The undersigned also agrees to jurisdiction and venue in Michigan." }), _jsx(Text, { style: styles.pBlock, children: "Terms of sale have been fully explained and it is understood that if the account is established, the credit line is subject to periodic review. Also shipments may be held if the account is delinquent or exceeds the established line of credit." }), _jsx(Text, { style: styles.pBlock, children: "The undersigned further represents that its professional licenses are in good standing and not the subject of any proceedings by any governmental agency and agrees to notify the seller immediately upon the commencement of any such proceedings. Customer and Guarantor agree to provide company with 60 days notice of its intention to sell all of its assets." }), _jsx(Text, { style: styles.pBlock, children: "All information stated above is correct to the best of your knowledge and you give permission for Auburn Pharmaceutical to verify any or all of this information and for all parties to release credit information to Auburn Pharmaceutical." }), _jsx(Text, { style: styles.pBlock, children: "By signing the credit agreement you acknowledge responsibility for payment by both the corporation, if any, and yourself individually." }), _jsxs(View, { style: styles.sigsContainer, children: [_jsx(View, { style: styles.col, children: signatures.left.map((sig, i) => _createElement(Signature, { ...sig, key: i })) }), _jsx(View, { style: styles.col, children: signatures.right.map((sig, i) => _createElement(Signature, { ...sig, key: i })) })] }), _jsxs(View, { style: styles.footer, children: [_jsx(Text, { style: styles.footerText, children: "1744 Rochester Industrial Drive, Rochester Hills, Michigan 48309 \u2022 800-222-5609 \u2022 FAX 248-526-3713" }), _jsx(Text, { style: styles.footerText, children: "E-mail address: accounting@auburnpharm.com" })] })] }), _jsx(Text, { style: { ...styles.p, position: 'absolute', bottom: 30, left: 30, }, children: "Rev 06/23/21" })] }));
});
;
const Signature = ({ label, value, }) => {
    const styles = StyleSheet.create({
        col: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            marginBottom: 25,
        },
        sigLabel: {
            fontSize: 9,
            fontFamily: 'Roboto',
            marginTop: 3,
        },
        sigVal: {
            fontSize: 12,
            fontFamily: 'Roboto',
            marginBottom: -15,
        },
    });
    return (_jsxs(View, { style: styles.col, children: [value && _jsx(Text, { style: styles.sigVal, children: value }), _jsx(Text, { children: "___________________" }), _jsx(Text, { style: styles.sigLabel, children: label })] }));
};
